// P2 follow-up (2026-09-19) — the pending-end sentence, in one place.
//
// It moved out of Checkout.vue's action column into the plan card's body
// (OrgSettings), because the action column does not shrink and the sentence
// widened it until the card body was 0px wide (measured in Chromium: see
// src/tests/orgSettingsPlanCard.test.js). Wording follows D5: a subscription
// ENDS ON A DATE. It is never described as "cancelled".

// Accepts a Firestore Timestamp, a Date, an ISO string or null.
export function toDate(value) {
  if (!value) return null;
  if (typeof value.toDate === "function") return value.toDate();
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function subscriptionEndsOnLabel(value) {
  const d = toDate(value);
  return d ? d.toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" }) : "";
}

// Empty when there is no readable date: the caller renders nothing rather than
// "ends on ." with a hole in it.
export function subscriptionEndsSentence(value) {
  const label = subscriptionEndsOnLabel(value);
  return label ? `Your subscription ends on ${label}. Everything keeps working until then.` : "";
}
